import React, { Component } from "react";
import Request from "superagent";
import PropTypes from "prop-types";

import { API_BASE } from "./api";
import { NFL_TEAMS } from "./nfl";
import { deserialize, VERSION as PICKS_VERSION } from "./Picks";
import { subscribe } from "./Scores";

function normalizePending(pending) {
  if (pending === undefined || pending === null) {
    return [7, 3];
  }
  return pending;
}

function arrayToBoard(arr) {
  // TODO (cleanup) This should be in picks
  const map = new Map();
  for (let i = 0; i < 10; i++) {
    for (let j = 0; j < 10; j++) {
      map[i + "," + j] = arr[i][j];
    }
  }
  return map;
}

class Game extends Component {
  static propTypes = {
    lobbyCode: PropTypes.string.isRequired,
    GameDisplay: PropTypes.any.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      scoreAway: 0,
      scoreHome: 0,
      picks: null,
      awayPeriods: null,
      homePeriods: null,
      awayPending: null,
      homePending: null,
    };

    this.onGameState = this.onGameState.bind(this);
    this.onConnStatus = this.onConnStatus.bind(this);
  }

  componentDidMount() {
    const { lobbyCode } = this.props;
    Request.get(`${API_BASE}/lobby/${lobbyCode}`).end((err, res) => {
      if (err) {
        alert("An error occurred. Please try reloading.");
        return;
      }

      const tmpBoard = res.body.data;
      tmpBoard.version = PICKS_VERSION;
      tmpBoard.board = arrayToBoard(tmpBoard.board);
      const picks = deserialize(JSON.stringify(tmpBoard));

      console.log(`game ${picks.gamekey}`, res.body.data);
      const data = res.body.data;
      this.setState({
        picks,
        gamekey: picks.gamekey,
        away: NFL_TEAMS[data.away],
        home: NFL_TEAMS[data.home],
        scoreAway: data.awayScore,
        scoreHome: data.homeScore,
        awayPeriods: data.awayPeriods,
        homePeriods: data.homePeriods,
        awayPending: normalizePending(data.awayPending),
        homePending: normalizePending(data.homePending),
      });
      this.scoreSub = subscribe(`game/${picks.gamekey}`, this.onGameState, this.onConnStatus);
    });
  }

  componentWillUnmount() {
    this.scoreSub && this.scoreSub.unsubscribe();
    this.scoreSub = null;
  }

  onGameState(gameState) {
    const nextAwayPeriods = Array.isArray(gameState.awayPeriods)
      ? gameState.awayPeriods
      : this.state.awayPeriods;
    const nextHomePeriods = Array.isArray(gameState.homePeriods)
      ? gameState.homePeriods
      : this.state.homePeriods;
    const nextAwayPending = Array.isArray(gameState.awayPending)
      ? normalizePending(gameState.awayPending)
      : this.state.awayPending;
    const nextHomePending = Array.isArray(gameState.homePending)
      ? normalizePending(gameState.homePending)
      : this.state.homePending;

    this.setState({
      scoreAway: gameState.scoreAway,
      scoreHome: gameState.scoreHome,
      awayPeriods: nextAwayPeriods,
      homePeriods: nextHomePeriods,
      awayPending: nextAwayPending,
      homePending: nextHomePending,
    });
  }

  onConnStatus(status) {}

  render() {
    const { GameDisplay } = this.props;
    const { picks, scoreAway, scoreHome, away, home } = this.state;
    if (!picks) {
      return <div />;
    }
    return (
      <GameDisplay
        scoreAway={scoreAway}
        scoreHome={scoreHome}
        awayPeriods={this.state.awayPeriods}
        homePeriods={this.state.homePeriods}
        awayPending={this.state.awayPending}
        homePending={this.state.homePending}
        away={away}
        home={home}
        picks={picks}
      />
    );
  }
}

export default Game;



// WEBPACK FOOTER //
// ./src/Game.js